import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImportStudentListComponent } from '../admin/overlay-container/visibility-room/import-student-list/import-student-list.component';
import { AssistantRestrictionComponent } from '../assistant-restriction/assistant-restriction.component';
import { BackpackModule } from '../backpack/backpack.module';
import { AnimatedHeaderDirective } from '../core/directives/animated-header.directive';
import { PassLimitDialogComponent } from '../create-hallpass-forms/main-hallpass--form/locations-group-container/pass-limit-dialog/pass-limit-dialog.component';
import { WhoYouAreComponent } from '../create-hallpass-forms/main-hallpass--form/student-groups/who-you-are/who-you-are.component';
import { DevPlaygroundComponent } from '../dev-playground/dev-playground.component';
import { InvitationCardComponent } from '../invitation-card/invitation-card.component';
import { KioskModeModule } from '../kiosk-mode/kiosk-mode.module';
import { KioskSettingsDialogComponent } from '../kiosk-settings-dialog/kiosk-settings-dialog.component';
import { MainPageComponent } from '../main-page/main-page.component';
import { NavbarComponent } from '../navbar/navbar.component';
import { NotificationRoomFormComponent } from '../notification-form/notification-room-form/notification-room-form.component';
import { ReportFormComponent } from '../report-form/report-form.component';
import { SharedModule } from '../shared/shared.module';
import { MainRoutingModule } from './main-routing.module';

@NgModule({
	imports: [CommonModule, SharedModule, MainRoutingModule, FormsModule, ReactiveFormsModule, KioskModeModule, BackpackModule],
	declarations: [
		// SettingsComponent,
		MainPageComponent,
		AnimatedHeaderDirective,
		NavbarComponent,
		AssistantRestrictionComponent,
		PassLimitDialogComponent,

		WhoYouAreComponent,
		InvitationCardComponent,
		ReportFormComponent,
		NotificationRoomFormComponent,
		KioskSettingsDialogComponent,
		ImportStudentListComponent,
		DevPlaygroundComponent,
	],
})
export class MainModule {}
